import { render, staticRenderFns } from "./backgroundcolor.vue?vue&type=template&id=b88be1cc&"
import script from "./backgroundcolor.vue?vue&type=script&lang=js&"
export * from "./backgroundcolor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports